<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="suburbViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'SUBURB',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        { text: 'HITS', align: 'start', sortable: true, value: 'total_views' }
      ],
      suburbViews: [],
      month: ''
    }
  },
  mounted() {
    this.getSuburbViews()
  },
  methods: {
    getSuburbViews() {
      this.loading = true
      axios
        .get(
          `api/get-suburb-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.suburbViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=suburb&name=SUBURB HITS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getSuburbViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
